(function() {
  let currentPrintifyMockupUrl = null;
  let currentMockups = [];
  let currentMockupsByColor = null;
  let currentSelectedColor = 'Black';
  let isApplying = false;
  let observer = null;

  // Dynamic mapping configuration for model mockups
  const COLOR_MODEL_MAP = {
    'black': {
      'person-2': { index: 1, filePattern: '13937979681132528929' },
      'person-6': { index: 2, filePattern: '1037255003287234509' }
    },
    'navy': {
      'person-2': { index: 3, filePattern: '10361744351042526036' },
      'person-6': { index: 4, filePattern: '12848247722925704281' }
    },
    'red': {
      'person-2': { index: 5, filePattern: '4919907230972520646' },
      'person-6': { index: 6, filePattern: '17833805923179950117' }
    }
  };

  function updateImage(img, newSrc, container = null) {
    if (!img || !newSrc) return;

    if (!img.hasAttribute('data-original-src')) {
      img.setAttribute('data-original-src', img.src || '');
      img.setAttribute('data-original-srcset', img.getAttribute('srcset') || '');
      if (img.hasAttribute('data_max_resolution')) {
        img.setAttribute('data-original-max-resolution', img.getAttribute('data_max_resolution') || '');
      }
    }

    if (container && !container.hasAttribute('data-original-src')) {
      container.setAttribute('data-original-src', img.getAttribute('data-original-src') || img.src || '');
      container.setAttribute('data-original-srcset', img.getAttribute('data-original-srcset') || img.getAttribute('srcset') || '');
      if (img.hasAttribute('data-original-max-resolution') || img.hasAttribute('data_max_resolution')) {
        container.setAttribute('data-original-max-resolution', img.getAttribute('data-original-max-resolution') || img.getAttribute('data_max_resolution') || '');
      }
    }

    img.removeAttribute('srcset');
    img.dataset.pawModified = 'true';
    img.src = newSrc;
    if (img.hasAttribute('data_max_resolution') || (container && container.hasAttribute('data-original-max-resolution'))) {
      img.setAttribute('data_max_resolution', newSrc);
    }
  }

  function restoreImage(img, container = null) {
    if (!img) return;
    const origSrc = img.getAttribute('data-original-src') || (container ? container.getAttribute('data-original-src') : null);
    if (origSrc) img.src = origSrc;
    const origSrcset = img.getAttribute('data-original-srcset') || (container ? container.getAttribute('data-original-srcset') : null);
    if (origSrcset) img.setAttribute('srcset', origSrcset);
    const origMaxRes = img.getAttribute('data-original-max-resolution') || (container ? container.getAttribute('data-original-max-resolution') : null);
    if (origMaxRes) img.setAttribute('data_max_resolution', origMaxRes);

    img.removeAttribute('data-original-src');
    img.removeAttribute('data-original-srcset');
    img.removeAttribute('data-original-max-resolution');
    delete img.dataset.pawModified;

    if (container) {
      container.removeAttribute('data-original-src');
      container.removeAttribute('data-original-srcset');
      container.removeAttribute('data-original-max-resolution');
    }
  }

  function restoreOriginals() {
    const allModified = document.querySelectorAll('img[data-original-src], img[data-paw-modified]');
    allModified.forEach(img => restoreImage(img, img.closest('slideshow-slide, li, button')));

    const allContainers = document.querySelectorAll('[data-original-src]');
    allContainers.forEach(el => {
      if (el.tagName !== 'IMG') {
        const img = el.querySelector('img');
        if (img) restoreImage(img, el);
        else {
          el.removeAttribute('data-original-src');
          el.removeAttribute('data-original-srcset');
          el.removeAttribute('data-original-max-resolution');
        }
      }
    });
  }

  function findSlideForView(slides, colorName, viewId) {
    const normColor = (colorName || 'black').toLowerCase().trim();
    const config = COLOR_MODEL_MAP[normColor]?.[viewId];
    if (!config) return null;

    // 1. Try matching by original file pattern if available
    if (config.filePattern) {
      for (let i = 0; i < slides.length; i++) {
        const img = slides[i].querySelector('img');
        const origSrc = img?.getAttribute('data-original-src') || img?.src || '';
        if (origSrc.includes(config.filePattern)) {
          return { slide: slides[i], index: i };
        }
      }
    }

    // 2. Fall back to slide index if valid
    if (config.index < slides.length) {
      return { slide: slides[config.index], index: config.index };
    }
    return null;
  }

  function performApply() {
    if (!currentPrintifyMockupUrl && (!currentMockups || currentMockups.length === 0) && !currentMockupsByColor) return;

    const slides = Array.from(document.querySelectorAll('slideshow-slide, .media-gallery__grid li'));
    const thumbnails = Array.from(document.querySelectorAll('.slideshow-controls__thumbnail'));
    const zoomSlides = Array.from(document.querySelectorAll('zoom-dialog .dialog-zoomed-gallery li, zoom-dialog [ref="media[]"]'));
    const zoomThumbnails = Array.from(document.querySelectorAll('zoom-dialog .dialog-thumbnails-list button, zoom-dialog [ref="thumbnails"] button'));

    if (slides.length === 0 && zoomSlides.length === 0) return;

    // Determine currently selected color dynamically from DOM if not passed
    const colorInput = document.querySelector('input[data-option-name="Color"]:checked, select[data-option-name="Color"]');
    const activeColor = (currentSelectedColor || colorInput?.value || 'Black').trim();
    const activeColorKey = activeColor.toLowerCase();

    const hasMultiColor = currentMockupsByColor && typeof currentMockupsByColor === 'object' && Object.keys(currentMockupsByColor).length > 0;

    // 1. Resolve Primary Front Mockup for active color
    let primaryMockupUrl = currentPrintifyMockupUrl;
    if (hasMultiColor && currentMockupsByColor[activeColorKey]) {
      const activeList = currentMockupsByColor[activeColorKey];
      const frontMockup = activeList.find(m => m.mockup_id === 'front-2' || m.mockup_id === 'front' || m.is_default) || activeList[0];
      if (frontMockup && frontMockup.src) {
        primaryMockupUrl = frontMockup.src;
      }
    } else if (currentMockups && currentMockups.length > 0) {
      const frontMockup = currentMockups.find(m => m.mockup_id === 'front-2' || m.mockup_id === 'front' || m.is_default);
      if (frontMockup && frontMockup.src) {
        primaryMockupUrl = frontMockup.src;
      }
    }

    // Set of image elements that SHOULD be updated
    const targetImages = new Set();

    // Update Slide 0 (Primary featured image) across Slideshow and Zoom Dialog
    if (primaryMockupUrl) {
      if (slides[0]) {
        const primarySlideImg = slides[0].querySelector('.product-media__image') || slides[0].querySelector('img');
        if (primarySlideImg) {
          updateImage(primarySlideImg, primaryMockupUrl, slides[0]);
          targetImages.add(primarySlideImg);
        }
      }
      if (thumbnails[0]) {
        const primaryThumbImg = thumbnails[0].querySelector('img');
        if (primaryThumbImg) {
          updateImage(primaryThumbImg, primaryMockupUrl, thumbnails[0]);
          targetImages.add(primaryThumbImg);
        }
      }
      if (zoomSlides[0]) {
        const zoomSlideImg = zoomSlides[0].querySelector('.product-media__image') || zoomSlides[0].querySelector('img');
        if (zoomSlideImg) {
          updateImage(zoomSlideImg, primaryMockupUrl, zoomSlides[0]);
          targetImages.add(zoomSlideImg);
        }
      }
      if (zoomThumbnails[0]) {
        const zoomThumbImg = zoomThumbnails[0].querySelector('img');
        if (zoomThumbImg) {
          updateImage(zoomThumbImg, primaryMockupUrl, zoomThumbnails[0]);
          targetImages.add(zoomThumbImg);
        }
      }
    }

    // 2. Resolve Model Mockups
    if (hasMultiColor) {
      // Multi-color mode: Update Black, Navy, and Red mockups across slideshow and zoom modal
      for (const [colorKey, viewMap] of Object.entries(COLOR_MODEL_MAP)) {
        const colorList = currentMockupsByColor[colorKey] || [];
        ['person-2', 'person-6'].forEach(viewId => {
          const mockupItem = colorList.find(m => m.mockup_id === viewId);
          if (mockupItem && mockupItem.src) {
            const match = findSlideForView(slides, colorKey, viewId);
            if (match && match.slide) {
              const slideImg = match.slide.querySelector('.product-media__image') || match.slide.querySelector('img');
              if (slideImg) {
                updateImage(slideImg, mockupItem.src, match.slide);
                targetImages.add(slideImg);
              }
              if (thumbnails[match.index]) {
                const thumbImg = thumbnails[match.index].querySelector('img');
                if (thumbImg) {
                  updateImage(thumbImg, mockupItem.src, thumbnails[match.index]);
                  targetImages.add(thumbImg);
                }
              }
              if (zoomSlides[match.index]) {
                const zoomSlideImg = zoomSlides[match.index].querySelector('.product-media__image') || zoomSlides[match.index].querySelector('img');
                if (zoomSlideImg) {
                  updateImage(zoomSlideImg, mockupItem.src, zoomSlides[match.index]);
                  targetImages.add(zoomSlideImg);
                }
              }
              if (zoomThumbnails[match.index]) {
                const zoomThumbImg = zoomThumbnails[match.index].querySelector('img');
                if (zoomThumbImg) {
                  updateImage(zoomThumbImg, mockupItem.src, zoomThumbnails[match.index]);
                  targetImages.add(zoomThumbImg);
                }
              }
            }
          }
        });
      }
    } else if (currentMockups && currentMockups.length > 0) {
      // Backward compatibility fallback for single-color responses
      ['person-2', 'person-6'].forEach(viewId => {
        const mockupItem = currentMockups.find(m => m.mockup_id === viewId);
        if (mockupItem && mockupItem.src) {
          const match = findSlideForView(slides, activeColor, viewId);
          if (match && match.slide) {
            const slideImg = match.slide.querySelector('.product-media__image') || match.slide.querySelector('img');
            if (slideImg) {
              updateImage(slideImg, mockupItem.src, match.slide);
              targetImages.add(slideImg);
            }
            if (thumbnails[match.index]) {
              const thumbImg = thumbnails[match.index].querySelector('img');
              if (thumbImg) {
                updateImage(thumbImg, mockupItem.src, thumbnails[match.index]);
                targetImages.add(thumbImg);
              }
            }
            if (zoomSlides[match.index]) {
              const zoomSlideImg = zoomSlides[match.index].querySelector('.product-media__image') || zoomSlides[match.index].querySelector('img');
              if (zoomSlideImg) {
                updateImage(zoomSlideImg, mockupItem.src, zoomSlides[match.index]);
                targetImages.add(zoomSlideImg);
              }
            }
            if (zoomThumbnails[match.index]) {
              const zoomThumbImg = zoomThumbnails[match.index].querySelector('img');
              if (zoomThumbImg) {
                updateImage(zoomThumbImg, mockupItem.src, zoomThumbnails[match.index]);
                targetImages.add(zoomThumbImg);
              }
            }
          }
        }
      });
    }

    // 3. Clean up any other gallery images that were previously modified
    const allModified = document.querySelectorAll('img[data-original-src], img[data-paw-modified]');
    allModified.forEach(img => {
      if (!targetImages.has(img)) {
        restoreImage(img, img.closest('slideshow-slide, li, button'));
      }
    });
  }

  function applyMockups() {
    if (isApplying) return;
    if (!currentPrintifyMockupUrl && (!currentMockups || currentMockups.length === 0) && !currentMockupsByColor) return;

    isApplying = true;
    if (observer) observer.disconnect();

    try {
      performApply();
    } finally {
      isApplying = false;
      ensureObserver();
    }
  }

  function ensureObserver() {
    if (observer) observer.disconnect();

    const persistentContainer = document.querySelector('.product-information')
      || document.querySelector('.product__media-wrapper')
      || document.querySelector('media-gallery')
      || document.body;

    if (!persistentContainer) return;

    observer = new MutationObserver((mutations) => {
      if (isApplying) return;
      if (!currentPrintifyMockupUrl && (!currentMockups || currentMockups.length === 0) && !currentMockupsByColor) return;

      let shouldReapply = false;
      for (const m of mutations) {
        if (m.type === 'childList') {
          for (const node of m.addedNodes) {
            if (node.nodeType === 1 && (node.matches('media-gallery, slideshow-slides, slideshow-slide, zoom-dialog, .dialog-zoomed-gallery, img') || node.querySelector('img'))) {
              shouldReapply = true;
              break;
            }
          }
        } else if (m.type === 'attributes') {
          if (m.target.tagName === 'IMG' && (m.attributeName === 'src' || m.attributeName === 'srcset')) {
            // If this change was made by our own code, ignore it
            if (m.target.dataset.pawModified === 'true' && m.target.getAttribute('data-original-src')) {
              continue;
            }
            shouldReapply = true;
          } else if (m.attributeName === 'class' || m.attributeName === 'aria-hidden') {
            shouldReapply = true;
          }
        }
        if (shouldReapply) break;
      }

      if (shouldReapply) {
        applyMockups();
      }
    });

    observer.observe(persistentContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['src', 'srcset', 'class', 'aria-hidden']
    });

    // Also observe zoom-dialog if outside persistentContainer
    const zoomDialog = document.querySelector('zoom-dialog');
    if (zoomDialog && !persistentContainer.contains(zoomDialog)) {
      observer.observe(zoomDialog, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['src', 'srcset', 'class', 'aria-hidden']
      });
    }
  }

  document.addEventListener('paw:update-preview', (e) => {
    const { printifyMockupUrl, printifyMockups, mockupsByColor, selectedColor } = e.detail;

    // Clean up any stale overlay elements
    const staleOverlays = document.querySelectorAll('.cc-preview-overlay');
    staleOverlays.forEach(overlay => overlay.remove());

    if (printifyMockupUrl || (printifyMockups && printifyMockups.length > 0) || mockupsByColor) {
      currentPrintifyMockupUrl = printifyMockupUrl || null;
      currentMockups = Array.isArray(printifyMockups) ? printifyMockups : [];
      currentMockupsByColor = mockupsByColor && typeof mockupsByColor === 'object' ? mockupsByColor : null;
      currentSelectedColor = selectedColor || 'Black';

      applyMockups();
    } else {
      currentPrintifyMockupUrl = null;
      currentMockups = [];
      currentMockupsByColor = null;
      if (observer) observer.disconnect();
      restoreOriginals();
    }
  });

  // Re-apply on section load or theme rehydration
  document.addEventListener('shopify:section:load', () => {
    if (currentPrintifyMockupUrl || (currentMockups && currentMockups.length > 0) || currentMockupsByColor) {
      applyMockups();
    }
  });
})();
